
import { ActionCardProps } from '@/types/action-card';
import { GlassActionCard } from './GlassActionCard';
import { ApiActionCard } from './ApiActionCard';
import { WorkflowActionCard } from './WorkflowActionCard';
import { ListCard } from './ListCard';
import { InputCard } from './InputCard';
import { DataTableCard } from './DataTableCard';
import { MediaCard } from './MediaCard';
import { NestedCard } from './NestedCard';

export const ActionCard = (props: ActionCardProps) => {
  const { data } = props;
  
  // Select the appropriate card component based on the action type
  switch (data.type) {
    case 'api':
      return <ApiActionCard {...props} />;
    case 'workflow':
      return <WorkflowActionCard {...props} />;
    case 'list':
      return <ListCard {...props} />;
    case 'input':
      return <InputCard {...props} />;
    case 'data-table':
      return <DataTableCard {...props} />;
    case 'media':
      return <MediaCard {...props} />;
    case 'nested':
      return <NestedCard {...props} />;
    case 'summary':
    case 'recommendation':
    default:
      // Fallback to GlassActionCard for any unspecified types
      return <GlassActionCard {...props} />;
  }
};
